import { sample } from 'effector';
import { spread } from 'patronum';
import { InvestProGate } from './events.js';
import invest_pro_admin from '../../data/InvestPro/invest_pro_admin.json';
import { $investProDistricts, $investProRegions } from './stores.js';

sample({
  clock: InvestProGate.open,
  fn: () => {
    return {
      regions: invest_pro_admin.features.filter(
        (item) => item.properties.ADMLVL === 1
      ),
      districts: invest_pro_admin.features.filter(
        (item) => item.properties.ADMLVL === 2
      ),
    };
  },
  target: spread({
    targets: {
      regions: $investProRegions,
      districts: $investProDistricts,
    },
  }),
});
